import { MapPin } from "lucide-react";
import { useLocationContext } from "@/contexts/LocationContext";

// Compact header control: "Your location: QLD — Change" or a prompt to choose.
export function LocationIndicator() {
  const { state, openSelector } = useLocationContext();

  return (
    <button
      onClick={openSelector}
      className="flex items-center gap-1.5 text-xs md:text-sm hover:text-accent transition-colors"
      aria-label="Change your selected location"
    >
      <MapPin className="h-4 w-4" />
      {state ? (
        <span>
          Your location: <span className="font-semibold">{state}</span> —{" "}
          <span className="underline">Change</span>
        </span>
      ) : (
        <span className="underline">Select your location</span>
      )}
    </button>
  );
}
